import { css } from '@emotion/core';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import { ConfirmationPage } from '@nexus/lib-react/dist/core/ConfirmationPage/ConfirmationPage';
import { Headline4 } from '@nexus/lib-react/dist/core/Typography/Heading';
import { Paragraph3 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled from '../../../theme/styled';

import mq from '../../styles/mediaQueries';

const Wrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    background-color: ${theme.colors['background-global-secondary']};

    ${mq.tablet} {
      padding-top: 56px;
    }
  `}
`;

const ConfirmationPageWrapper = styled(ConfirmationPage)`
  ${css`
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-align: center;

    ${mq.tablet} {
      border: 16px solid white;
      box-sizing: border-box;
      max-width: 824px;
      max-height: 426px;
    }
  `}
`;

const Headline = styled(Headline4)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes['20']};
      font-weight: ${theme.fontWeights['600']};
      margin-bottom: ${theme.sizes['16']};
    `}
`;

const Paragraph = styled(Paragraph3)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes['14']};
      font-weight: ${theme.fontWeights['400']};
      margin-bottom: ${theme.sizes['24']};
    `}
`;

const RedirectButton = styled(ButtonPrimaryDark)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes['14']};
      margin-bottom: ${theme.sizes['14']};
      line-height: ${theme.lineHeights['18']};
    `}
`;

export default {
  ConfirmationPageWrapper,
  Headline,
  Paragraph,
  RedirectButton,
  Wrapper,
};
